// src/content/qsoil/content.ts
import { Content } from "../../common/types/types";
import heroImage from "../../assets/client_qsoil/about/1.webp";
import sectionImage2 from "../../assets/client_qsoil/about/2.webp";
import sectionImage3 from "../../assets/client_qsoil/about/3.webp";

export const content: Content = {
  about: {
    title: "О бренде QS — собственное направление компании «Карьер-Сервис»",
    metaDescription:
      "QS — это собственное продуктовое направление ООО «Карьер-Сервис». Мы поставляем и обслуживаем оборудование для горной промышленности...",
    heroImage,
    heroImageAlt:
      "Парк дробильно-сортировочного оборудования компании «Карьер-Сервис»",
    intro: `QS — это собственное продуктовое направление ООО «Карьер-Сервис», входящего в QS Group. Компания поставляет и обслуживает оборудование для горной промышленности, поэтому требования к продуктам формируются на основе практического опыта эксплуатации техники в сложных условиях.

Мы — не просто продавец ГСМ и технической химии. Мы — потребители, такие же, как вы. Наша компания эксплуатирует дорогостоящее дробильно-сортировочное оборудование (ДСО), карьерную и тяжёлую спецтехнику.

В собственности — более 50 единиц оборудования для переработки горной массы, работающего 24/7, и автопарк более 100 автомобилей, эксплуатируемых в сложных климатических, дорожных и бездорожных условиях.`,
    sections: [
      {
        title: "Почему мы начали производить собственные ГСМ?",
        text: `Потому что мы точно знаем: в горнодобывающей отрасли час простоя оборудования измеряется сотнями тысяч рублей. Авария из-за неподходящего масла или смазки — это не просто ремонт, это остановка производства, срыв сроков и потеря безопасности.

Мы разрабатывали масла, смазки и техническую химию в первую очередь для себя — чтобы:
• увеличить ресурс основных узлов и агрегатов;
• исключить аварийные и внеплановые простои;
• повысить безопасность производственных процессов;
• снизить затраты на ТО и ремонт.

Результат: мы полностью перешли на собственные ГСМ и значительно повысили КТГ (коэффициент технической готовности) оборудования.`,
        image: sectionImage2,
      },
      {
        title: "Что мы предлагаем клиентам",
        text: `Линейки QS OIL, QS GREASE, QS BOND и QS FILTERS предназначены для промышленного оборудования, дробильно-сортировочной и специальной техники.

• Масла QS OIL — для ДВС, трансмиссий, редукторов, гидросистем, промышленных узлов.
• Смазки QS GREASE — для тяжелонагруженных подшипников, шлицев, открытых передач, виброузлов.
• Компаунд QS BOND — заливочная смесь для фиксации, герметизации, защиты и восстановления узлов.

Наши принципы:
• Честность — мы продаём только то, что используем сами.
• Инженерный подход — подбираем продукт под конкретный узел и условия.
• Поддержка — консультируем на всех этапах: от подбора до эксплуатации.
• Ответственность — за результат отвечаем репутацией и своим оборудованием.`,
        image: sectionImage3,
      },
    ],
  },
};
